import { useState } from "react"
import BubbleText from "@/components/BubbleText"
import SidePanel from "@/components/SidePanel"
import { useAppDispatch, useAppSelector } from "@/core/root-reducer"
import preventionActionStore from "@/entities/prevention-action/model/prevention-action.store"
import { isPreventionActionWithoutDate } from "@/entities/prevention-action/model/prevention-action.utils"
import PreventionActionCalendarItem from "@/entities/prevention-action/ui/PreventionActionCalendarItem"
import PreventionActionAddModal from "@/entities/prevention-action/ui/modal/PreventionActionAddModal"

export default function CalendarFilterPanel() {
  const dispatch = useAppDispatch()
  const actionsWithoutDate = useAppSelector(preventionActionStore.selectors.list).filter(isPreventionActionWithoutDate)
  const [isEditModalOpen, setIsEditModalOpen] = useState(false)

  //La modale reste montee meme quand la liste se vide : dater la derniere mesure la ferme sinon
  //en plein enregistrement, et l'etape de reevaluation du niveau de prevention est perdue
  return (
    <>
      {isEditModalOpen && <PreventionActionAddModal isEditing onClose={() => setIsEditModalOpen(false)} />}

      <SidePanel width={380} defaultOpen={actionsWithoutDate.length > 0} side="left" scrollClassName="!overflow-hidden">
        <div className="box-border flex h-full min-h-0 flex-col">
          <div className="relative flex shrink-0 items-start px-[30px] pb-[30px] pt-[28px]">
            <img
              src={require("@/assets/owl.png")}
              alt="Hibou IDTree"
              className="absolute h-auto w-[130px]"
              style={{ left: -52, top: -20, transform: "rotate(42deg)" }}
            />
            <div className="ml-[65px] min-w-0 flex-1 pt-10">
              <BubbleText orientation="left">
                <span className="block text-base font-semibold leading-snug text-slate-900">
                  {actionsWithoutDate.length > 0
                    ? "Les mesures prévues suivantes n’ont pas de dates définies"
                    : "Toutes les mesures prévues sont planifiées dans le calendrier"}
                </span>
              </BubbleText>
            </div>
          </div>

          <div className="min-h-0 flex-1 overflow-y-auto">
            <div className="flex flex-col gap-10 px-[30px] pb-[30px]">
              {actionsWithoutDate.map((action) => (
                <div key={action.id} className="shrink-0">
                  <PreventionActionCalendarItem
                    action={action}
                    displayDragHandle
                    draggable
                    onDragStart={(event) => {
                      event.dataTransfer.effectAllowed = "move"
                      event.dataTransfer.setData("application/x-prevention-action-id", action.id)
                      event.dataTransfer.setData("text/plain", action.id)
                    }}
                    onClick={() => {
                      dispatch(preventionActionStore.actions.setActive(action))
                      setIsEditModalOpen(true)
                    }}
                  />
                </div>
              ))}
            </div>
          </div>
        </div>
      </SidePanel>
    </>
  )
}
